import type { ReactNode } from "react";
import { Button } from "@heroui/react";
import { ArrowUpRight } from "lucide-react";
import { demoEmailUrl } from "./demo-contact";
import "./marketing.css";

export function BookDemoButton({
  variant = "primary",
  size = "md",
}: {
  variant?: "primary" | "outline";
  size?: "sm" | "md";
}) {
  return (
    <Button
      variant={variant}
      size={size}
      onPress={() => window.location.assign(demoEmailUrl())}
    >
      Book a demo <ArrowUpRight size={15} aria-hidden="true" />
    </Button>
  );
}

/** Both public pages share the same brand, navigation and responsive geometry. */
export function MarketingHeader({
  actions,
  product = false,
}: {
  actions: ReactNode;
  product?: boolean;
}) {
  return (
    <header className="marketing-header">
      <nav className="marketing-header-inner" aria-label="Main navigation">
        <a className="marketing-brand" href="/" aria-label="Calque home">
          <svg viewBox="0 0 28 28" fill="none" aria-hidden="true">
            <path
              d="M3 3H19V19H3Z M9 9H25V25H9Z"
              stroke="currentColor"
              strokeWidth="1.6"
            />
          </svg>
          calque
        </a>
        <a
          className="marketing-product-link"
          href="/product"
          aria-current={product ? "page" : undefined}
        >
          Product
        </a>
        <div className="marketing-header-actions">{actions}</div>
      </nav>
    </header>
  );
}
